import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {FETCH_VALID_CEQ_TEST_DATE_LISTING_URL} from '../../constants/apiUrls';
import {useCustomQuery} from '../../hooks/query';
import {GET_VALID_CEQ_TEST_DATE_LISTING_QUERY_KEY} from '../../constants/queryKeys';

// =============================================================================
// Request & Response Model
// =============================================================================

export interface ValidCeqTestDateListingResponse {
  data: ValidCeqTestDateModelResponse[];
  lastUpdatedBy?: string;
  lastUpdatedAt?: string;
}

export interface ValidCeqTestDateModelResponse {
  uuid: string;
  firstAcceptedCeqTestDate: string;
  lastAcceptedCeqTestDate: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  registrationExamLevelUuid: string;
  admissionYear: number;
  onSuccess?: (data: ValidCeqTestDateListingResponse) => void;
  onError?: (data: AxiosError) => void;
  enabled: boolean;
}

export const useGetValidCeqTestDates = ({
                                          registrationExamLevelUuid,
                                          admissionYear,
                                          onSuccess,
                                          onError,
                                          enabled = false,
                                        }: Input) => {
  const getValidCeqTestDates = async () => {
    const res = await axiosClient.get<ValidCeqTestDateListingResponse>(
        FETCH_VALID_CEQ_TEST_DATE_LISTING_URL(registrationExamLevelUuid, admissionYear)
    );
    return res.data;
  };

  return useCustomQuery(
      [GET_VALID_CEQ_TEST_DATE_LISTING_QUERY_KEY, registrationExamLevelUuid, admissionYear],
      getValidCeqTestDates,
      {
        onSuccess,
        onError,
        enabled,
      },
      true,
      false
  );
};
